import styled from 'styled-components';

export const CONTAINER_PADDING_X = '10px';

export const BlockIconSpan = styled.span`
  display: inline-block;
  width: 1rem;
  text-align: center;
`;

export const RoundedGreyContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 10px;
  background-color: #eeeeee;
  padding: 6px ${CONTAINER_PADDING_X};
`;

export const GreyPill = styled.div`
  align-items: center;
  border-radius: 0.5em;
  background: ${({ background }) => background || '#eeeeee'};
  padding: 2px 6px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8em; // to match font-tiny
`;
